<mat-sidenav-container class="sidenav">
  <mat-sidenav #sidenav [opened]="model.open" (keydown.escape)="close()" mode="over" fixedInViewport="true"
    position="end">
    <div #header class="sidenav-header header-title" fxFlex="none" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
        <div class="title">{{ "authorization.confirm.title" | translate }}</div>
      </div>
      <div class="close" (click)="close()" color="warn" fxLayoutAlign="center center">
        <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
      </div>
    </div>
    @if(!saved){
    <mat-card>
      <div appearance="outlined" fxLayout="column" fxLayout.lt-md="column" class="service-container no-padding">
        <div class="confirm-publication">

          <div class="sidenav-content">
            <div class="sidenav-container" fxLayout="column" fxLayoutAlign="start center">
              <ng-container>
                <div class="sidenav-icon mb-4" fxLayout="row" fxLayoutAlign="center center">
                  <mat-icon class="ic-34 fc-6" aria-hidden="false" aria-label="publish">publish</mat-icon>
                </div>
                <div class="fs-18 fc-3 mb-4">
                  {{ "authorization.confirm.subtitle" | translate }}
                </div>
                <div class="info-text fs-14 fc-6">
                  {{
                  "authorization.confirm.info" | translate
                  }}
                </div>
              </ng-container>
            </div>
          </div>
          <div class="hr">
            <hr>
          </div>
          <div class="sidenav-footer" fxLayout="row" fxLayoutAlign="space-between center">
            <ng-container>
              <a mat-dialog-close fxShow fxHide.lt-md>{{
                "authorization.confirm.cancel" | translate
                }}</a>
              <button (click)="yes()" mat-flat-button color="primary">
                {{ "authorization.confirm.yes_publish" | translate }}
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </mat-card>
    }
    @if(saved){

    <mat-card>
      <div appearance="outlined" fxLayout="column" fxLayout.lt-md="column" class="service-container no-padding">
        <div class="confirm-publication">

          <div class="sidenav-content">
            <div class="sidenav-container" fxLayout="column" fxLayoutAlign="start center">
              <ng-container>
                <div class="mb-4" fxLayout="row" fxLayoutAlign="center center">       
                  <mat-icon class="icon-success-color" svgIcon="icon_success-color"></mat-icon>
                </div>
                <div class="fs-18 fc-3 mb-4">
                  {{ "authorization.confirm.finish" | translate }}
                </div>
                <div class="info-text fs-14 fc-6">
                  {{
                  "authorization.confirm.finish_info" | translate
                  }}
                </div>
              </ng-container>
            </div>
          </div>
          <div class="hr">
            <hr>
          </div>
          <div class="sidenav-footer" fxLayout="row" fxLayoutAlign="space-between center">
            <ng-container>
              <a (click)="closeReload()" fxShow fxHide.lt-md>{{
                "authorization.confirm.cancel" | translate
                }}</a>
              <button (click)="goToFlows()" mat-flat-button color="primary">
                {{ "authorization.confirm.go_to_flows" | translate }}
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </mat-card>
    }
    <div class="txt-bottom">{{ "authorization.confirm.reflection_time" | translate }}</div>
  </mat-sidenav>
</mat-sidenav-container>
